// Module
var code = "<product-development-overview\n  is-matrix=\"vm.isMatrix\"\n  variant-id=\"vm.variant.id\"\n></product-development-overview>\n";
// Exports
module.exports = code;